// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoModal__modal--QwHT {
    width: 100vw;
    height: 100%;
    height: calc(var(--vh) * 100);
}

    @media screen and (min-width: 1024px) {.InfoModal__modal--QwHT {
        width: 42vw;
        height: 324px;
        border-radius: 6px
}
    }

.InfoModal__content--juNn {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
}

.InfoModal__header--eDU7 {
    display: grid;
    grid-template-columns: auto 40px;
    grid-gap: 16px;
    padding: 16px 16px 0 16px;
}

@media screen and (min-width: 1024px) {

.InfoModal__header--eDU7 {
        padding: 32px 32px 0 32px
}
    }

.InfoModal__main--NMtT {
    padding: 0 16px;
}

@media screen and (min-width: 1024px) {

.InfoModal__main--NMtT {
        padding: 0 32px
}
    }

.InfoModal__footer--LBjn {
    margin-top: auto;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    position: sticky;
    bottom: 0;
    left: 0;
    padding: 0 16px 16px 16px;
}

@media screen and (min-width: 1024px) {

.InfoModal__footer--LBjn {
        padding: 0 32px 32px 32px;
        flex-direction: row
}
    }

@media screen and (max-width: 1023px) {
        .InfoModal__footer--LBjn > button {
            width: 100%;
        }
    }

.InfoModal__footer--LBjn > button {
        font-size: 12px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.05em;
        padding: 7px 24px;
    }

.InfoModal__title--Eq0N {
    font-size: 22px;
    font-weight: 700;
    line-height: 32px;
    color: var(--secondary-color);
}

.InfoModal__button--hmBG {
    width: 100%;
}

@media screen and (min-width: 1024px) {

.InfoModal__button--hmBG {
        width: auto
}
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/InfoModal/InfoModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,6BAA6B;AAOjC;;IALI,uCALJ;QAMQ,WAAW;QACX,aAAa;QACb;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,yBAAyB;AAK7B;;AAHI;;AANJ;QAOQ;AAER;IADI;;AAGJ;IACI,eAAe;AAKnB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,yBAAyB;AAoB7B;;AAlBI;;AAZJ;QAaQ,yBAAyB;QACzB;AAgBR;IAfI;;AAEA;QACI;YACI,WAAW;QACf;IACJ;;AAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,iBAAiB;IACrB;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AAKf;;AAHI;;AAHJ;QAIQ;AAER;IADI","sourcesContent":[".modal {\n    width: 100vw;\n    height: 100%;\n    height: calc(var(--vh) * 100);\n\n    @media (--large) {\n        width: 42vw;\n        height: 324px;\n        border-radius: 6px;\n    }\n}\n\n.content {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    overflow-y: auto;\n}\n\n.header {\n    display: grid;\n    grid-template-columns: auto 40px;\n    grid-gap: 16px;\n    padding: 16px 16px 0 16px;\n\n    @media (--large) {\n        padding: 32px 32px 0 32px;\n    }\n}\n\n.main {\n    padding: 0 16px;\n\n    @media (--large) {\n        padding: 0 32px;\n    }\n}\n\n.footer {\n    margin-top: auto;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 16px;\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    padding: 0 16px 16px 16px;\n\n    @media (--large) {\n        padding: 0 32px 32px 32px;\n        flex-direction: row;\n    }\n\n    @media (--mobile) {\n        > button {\n            width: 100%;\n        }\n    }\n\n    > button {\n        font-size: 12px;\n        font-weight: 700;\n        line-height: 24px;\n        letter-spacing: 0.05em;\n        padding: 7px 24px;\n    }\n}\n\n.title {\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 32px;\n    color: var(--secondary-color);\n}\n\n.button {\n    width: 100%;\n\n    @media (--large) {\n        width: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `InfoModal__modal--QwHT`,
	"content": `InfoModal__content--juNn`,
	"header": `InfoModal__header--eDU7`,
	"main": `InfoModal__main--NMtT`,
	"footer": `InfoModal__footer--LBjn`,
	"title": `InfoModal__title--Eq0N`,
	"button": `InfoModal__button--hmBG`
};
export default ___CSS_LOADER_EXPORT___;
